import React from 'react';

import {
  Container,
  ContainerIMG,
  Logo,
  ContainerTitle,
} from './styles';

import {
  TextCustom,
} from '../styles';

const Header = ({ company }) => (
  <Container>
    <ContainerIMG>
      <Logo
        cache={false}
        source={
          process.env.NODE_ENV === 'production'
            ? `${company.logo_url}?noCache=${Math.random().toString()}`
            : `${company.logo_url.replace(/^https:\/\//i, 'http://')}?noCache=${Math.random().toString()}`
        }
      />
    </ContainerIMG>
    <ContainerTitle>
      <TextCustom size="18px" bold>
        Há uma
        <TextCustom size="18px" bold color="#F07E31"> solicitação de manutenção </TextCustom>
        no seu imóvel
      </TextCustom>
      <TextCustom size="12px" margin="5px 0 0 0">Sua aprovação é necessária para a realização do serviço</TextCustom>
    </ContainerTitle>
  </Container>

);

export default Header;
